import React, { useEffect, useRef, useState } from "react";
import "../../styles/admin/iqTestCreate.scss";
import CloseIcon from "@mui/icons-material/Close";
import Switch from "@mui/material/Switch";
import { GENERATE_AI_IQ_TEST_QUESTION } from "../../helper/apiurls/apiurls";
import Cookies from "js-cookie";
import DropdownSelect from "../common/DropdownSelect";
import {
  createIQTestQuestion,
  updateIQTestQuestion,
} from "../../helper/apicalls/iqTest";
import { AddCircleIcon, DeleteIcon } from "../../icons";

const IqTestCreate = ({
  isOpen,
  onClose,
  isReferesh,
  setIsReferesh,
  setIsShowIQTestPreview,
  setShowPreviewQuestion,
  showPreviewQuestion,
  editableListQuestion,
  setIsEditAction,
  isEditAction,
  title = "Iq Test",
  type = "iq",
}) => {
  const websocketRef = useRef(null);
  const auth_token = Cookies.get("admin_token");
  const aiCategories = [
    { label: "Cognitive function", value: "cognitive_function" },
    { label: "Social emotional skill", value: "social_emotional_skill" },
    {
      label: "Physical development skill",
      value: "physical_development_skill",
    },
    { label: "Creative imagination", value: "creative_imagination" },
    {
      label: "Critical thinking curiosity",
      value: "critical_thinking_curiosity",
    },
    { label: "Language communication", value: "language_communication" },
    { label: "Self regulation behavior", value: "self_regulation_behavior" },
  ];

  const [activeTab, setActiveTab] = useState(isEditAction ? 1 : 0);
  const [prompt, setPrompt] = useState("");
  const [name, setName] = useState("");
  const [duration, setDuration] = useState(0);
  const [total, setTotal] = useState(0);
  const [aiGenerateStatus, setAiGenerateStatus] = useState("");
  const [questionErrors, setQuestionErrors] = useState({});

  const [switchState, setSwitchState] = useState(
    aiCategories.reduce((acc, item) => {
      acc[item.value] = false;
      return acc;
    }, {})
  );

  const [contentData, setContentData] = useState([
    {
      sequence: 1,
      categories: null,
      hint: "",
      content: {
        answer: "",
        options: { A: "" },
        question: "",
      },
      type: "mcq",
    },
  ]);
  const [categoriesInputValue, setCategoriesInputValue] = useState({});

  const getCategoriesValue = (key) => {
    const aiCategoriesValue = aiCategories?.filter((i) => i?.value === key);
    return aiCategoriesValue[0];
  };

  const handleTotalCount = async () => {
    let t = 0;
    Object.entries(categoriesInputValue || {}).map(
      ([key, value]) => (t += parseInt(value || 0))
    );
    setTotal(t);
  };

  const handleCheckboxChange = (key) => {
    setSwitchState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleAIGenerateIQQuestion = () => {
    if (!prompt) return;

    const countString = Object.entries(categoriesInputValue || {})
      .map(([key, value]) => `${key} ${value} question`)
      .join(", ");

    const p = `${prompt} with a total of ${total} questions. ${
      countString ? `The test should include ${countString}.` : ""
    }`;

    if (websocketRef.current?.readyState === WebSocket.OPEN) {
      websocketRef.current.close();
    }

    websocketRef.current = new WebSocket(GENERATE_AI_IQ_TEST_QUESTION);

    websocketRef.current.onopen = () => {
      console.log("WS opened");
      websocketRef.current.send(
        JSON.stringify({ prompt: p, type: type, token: auth_token })
      );
    };

    websocketRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setAiGenerateStatus(data?.status || "");
      console.log("Parse", data);

      if (data.status === "completed") {
        setShowPreviewQuestion(data?.data?.structured?.content);
      }
    };

    websocketRef.current.onerror = (e) => {
      console.error("WS error", e);
    };

    websocketRef.current.onclose = (e) => {
      console.log("WS closed", e.code, e.reason);
    };
  };

  const handleClickSaveContent = async () => {
    let contentToSave = showPreviewQuestion;
    
    if (activeTab === 0 && showPreviewQuestion?.[0]?.content) {
      contentToSave = showPreviewQuestion;
    }
    else if (activeTab === 1) {
      contentToSave = contentData;
    }
    
    const isValid = validateQuestionStructure(contentToSave);
    if (!isValid) {
      console.log("Validation failed", questionErrors);
      return;
    }
    const p = contentToSave?.map((d) => {
      const update = {
        ...d,
        categories: d?.categories?.value || d?.categories,
      };
      return update;
    });

    const payload = {
      content: p,
      test_type: type,
      name: name,
      duration: parseInt(duration),
    };

    if (isEditAction) {
      try {
        const res = await updateIQTestQuestion(
          auth_token,
          payload,
          editableListQuestion?.id
        );
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        const res = await createIQTestQuestion(auth_token, payload);
      } catch (err) {
        console.error(err);
      }
    }
    setIsReferesh(!isReferesh);
    onClose();
  };

  const handleClickAddContent = () => {
    const newIndex = contentData?.length || 0;

    setContentData((prev) => [
      ...(Array.isArray(prev) ? prev : []),
      {
        sequence: newIndex + 1,
        categories: null,
        hint: "",
        content: {
          answer: "",
          options: { A: "", B: "" },
          question: "",
        },
        type: "mcq",
      },
    ]);
  };
  const validateQuestionStructure = (contentToValidate = contentData) => {
    const errors = {};

    contentToValidate?.forEach((item, index) => {
      const itemErrors = {};

      if (!item?.categories) {
        itemErrors.categories = "Category is required";
      }

      if (!item?.hint?.trim()) {
        itemErrors.hint = "Hint is required";
      }

      if (!item?.content?.question?.trim()) {
        itemErrors.question = "Question is required";
      }

      if (!item?.content?.answer?.trim()) {
        itemErrors.answer = "Answer is required";
      }

      const options = item?.content?.options || {};
      const optionValues = Object.values(options).filter(Boolean);

      if (optionValues.length < 4) {
        itemErrors.options = "Minimum 4 options are required";
      }

      if (Object.keys(itemErrors).length > 0) {
        errors[index] = itemErrors;
      }
    });

    setQuestionErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleRemoveContent = (idx) => {
    setContentData((prev) => {
      const next = [...prev.slice(0, idx), ...prev.slice(idx + 1)];
      return next.map((item, i) => ({ ...item, sequence: i + 1 }));
    });
  };

  const addOption = (cIdx) => {
    setContentData((prev) => {
      const next = [...prev];

      const opts = { ...next[cIdx].content.options };
      const keys = Object.keys(opts);
      const nextKey = String.fromCharCode(65 + keys.length);

      opts[nextKey] = "";

      next[cIdx] = {
        ...next[cIdx],
        content: {
          ...next[cIdx].content,
          options: opts,
        },
      };

      return next;
    });
  };

  const updateOption = (cIdx, key, val) => {
    setContentData((prev) => {
      const next = [...prev];
      const opts = { ...next[cIdx].content.options };

      opts[key] = val;

      next[cIdx] = {
        ...next[cIdx],
        content: {
          ...next[cIdx].content,
          options: opts,
        },
      };

      return next;
    });
  };

  const removeOption = (cIdx, key) => {
    setContentData((prev) => {
      const next = [...prev];
      const opts = { ...next[cIdx].content.options };

      delete opts[key];

      next[cIdx] = {
        ...next[cIdx],
        content: {
          ...next[cIdx].content,
          options: opts,
        },
      };

      return next;
    });
  };

  useEffect(() => {
    setShowPreviewQuestion(contentData);
  }, [contentData]);

  useEffect(() => {
    const p = editableListQuestion?.content?.map((d) => {
      const update = {
        ...d,
        categories: getCategoriesValue(d?.categories),
      };
      return update;
    });

    setShowPreviewQuestion(p || []);
    setContentData(p || []);
    setDuration(editableListQuestion?.duration || 0);
    setName(editableListQuestion?.name);
  }, [editableListQuestion]);

  useEffect(() => {
    if (Object.keys(editableListQuestion || {}).length === 0) {
      setContentData([
        {
          sequence: 1,
          categories: null,
          hint: "",
          content: {
            answer: "",
            options: { A: "", B: "" },
            question: "",
          },
          type: "mcq",
        },
      ]);
    }
  }, []);

  useEffect(() => {
    handleTotalCount();
  }, [categoriesInputValue]);

  return (
    <div className="iq-test-create-popup-overlay">
      <div className="iq-test-create-main-container">
        <div className="iq-test-create-header-container">
          <h2>
            {isEditAction ? "Update" : "Create"} {title}
          </h2>
          <button
            className="iq-test-create-header-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div className="iq-test-create-main-container-info">
          {!isEditAction && (
            <div className="iq-test-create-generator-tabs">
              <div
                className={`iq-test-create-generator-tab ${
                  activeTab === 0 ? "active" : ""
                }`}
                onClick={() => setActiveTab(0)}
              >
                Generate with AI
              </div>
              <div
                className={`iq-test-create-generator-tab ${
                  activeTab === 1 ? "active" : ""
                }`}
                onClick={() => setActiveTab(1)}
              >
                {" "}
                Manual
              </div>
            </div>
          )}
          <div className="iq-test-create-question-generate-container">
            {activeTab === 0 && (
              <>
                <div className="iq-test-create-ai-question-container">
                  <div className="iq-test-create-ai-question-input-grid">
                    <div className="iq-test-create-ai-input-name-group">
                      <label className="iq-test-create-ai-input-name-label">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="iq-test-create-ai-text-input-name"
                        placeholder="Enter test name"
                        value={name}
                        onChange={(event) => {
                          setName(event.target.value);
                        }}
                      />
                    </div>
                    {/* <div className="iq-test-create-ai-input-group">
                      <label className="iq-test-create-ai-input-label">
                        Total
                      </label>
                      <input
                        type="number"
                        name="total"
                        className="iq-test-create-ai-text-input"
                        placeholder="Enter total"
                        value={total}
                        onChange={(event) => {
                          setTotal(event.target.value);
                        }}
                      />
                    </div> */}
                    <div className="iq-test-create-ai-input-group">
                      <label className="iq-test-create-ai-input-label">
                        Duration
                      </label>
                      <input
                        type="number"
                        name="total"
                        className="iq-test-create-ai-text-input"
                        placeholder="Enter total"
                        value={duration}
                        onChange={(event) => {
                          setDuration(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="iq-test-create-ai-input-group">
                      <label className="iq-test-create-ai-input-label">
                        Prompt
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="iq-test-create-ai-text-input"
                        placeholder="Enter prompt"
                        value={prompt}
                        onChange={(event) => {
                          setPrompt(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="iq-test-create-ai-categories-type-container">
                    <div className="iq-test-create-ai-categories-header">
                      Categories
                    </div>
                    <div className="ai-categories-input-container">
                      {aiCategories?.map((d, i) => {
                        return (
                          <div key={i} className="ai-categories-input-info">
                            <div className="ai-categories-input-switch-container">
                              <div className="ai-categories-input-label">
                                {d.label}
                              </div>

                              <Switch
                                checked={switchState[d.value]}
                                onChange={() => handleCheckboxChange(d.value)}
                                size="small"
                              />
                            </div>

                            {switchState?.[d?.value] && (
                              <input
                                type="number"
                                name="name"
                                className="ai-categories-text-input"
                                placeholder="No.of count"
                                value={categoriesInputValue?.[d.value] ?? ""}
                                onChange={(event) => {
                                  setCategoriesInputValue((prev) => ({
                                    ...prev,
                                    [d?.value]: event?.target?.value,
                                  }));
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="iq-test-create-ai-categories-action-container-ai">
                  <button
                    className="iq-test-create-ai-btn"
                    onClick={handleAIGenerateIQQuestion}
                    disabled={aiGenerateStatus === "processing"}
                    style={
                      aiGenerateStatus === "processing"
                        ? { opacity: "0.6", cursor: "not-allowed" }
                        : {}
                    }
                  >
                    Generate
                  </button>
                  <button
                    className={`iq-test-create-ai-btn ${
                      aiGenerateStatus !== "completed" ? "disable-btn" : ""
                    }`}
                    onClick={handleClickSaveContent}
                  >
                    Save
                  </button>

                  <button
                    className={`iq-test-create-ai-btn ${
                      aiGenerateStatus !== "completed" ||
                      !showPreviewQuestion ||
                      showPreviewQuestion.length === 0
                        ? "disable-btn"
                        : ""
                    }`}
                    disabled={
                      aiGenerateStatus !== "completed" ||
                      !showPreviewQuestion ||
                      showPreviewQuestion.length === 0
                    }
                    onClick={() => {
                      if (
                        aiGenerateStatus !== "completed" ||
                        !showPreviewQuestion ||
                        showPreviewQuestion.length === 0
                      )
                        return;
                      setIsShowIQTestPreview(true);
                    }}
                  >
                    Show questions
                  </button>
                </div>
              </>
            )}
            {activeTab === 1 && (
              <div className="iq-test-create-ai-manual-container">
                <div className="iq-test-create-ai-manual-info">
                  <div className="iq-test-create-ai-manual-input-container">
                    <div className="iq-test-create-ai-input-name-group">
                      <label className="iq-test-create-ai-input-name-label">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="iq-test-create-ai-text-input-name"
                        placeholder="Enter test name"
                        value={name}
                        onChange={(event) => {
                          setName(event.target.value);
                        }}
                      />
                    </div>
                    <div className="iq-test-create-ai-input-name-group">
                      <label className="iq-test-create-ai-input-name-label">
                        Duration
                      </label>
                      <input
                        type="number"
                        name="duration"
                        className="iq-test-create-ai-text-input-name"
                        placeholder="Enter duration"
                        value={duration}
                        onChange={(event) => {
                          setDuration(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="q-test-create-ai-manual-question-generate-container">
                    <div className="manual-question-generate-header">
                      <h3>Content</h3>
                    </div>
                    <div className="manual-question-generate-info">
                      {contentData?.map((content, index) => (
                        <div
                          key={`content-${index}`}
                          className="manual-question-explanation-container"
                        >
                          <div className="manual-question-row">
                            <DropdownSelect
                              inputId={`question-type-${index}`}
                              options={aiCategories}
                              value={content?.categories}
                              onChange={(vals) => {
                                setContentData((prev) => {
                                  const updated = [...prev];
                                  updated[index] = {
                                    ...updated[index],
                                    categories: vals,
                                  };
                                  return updated;
                                });
                              }}
                              placeholder="Select categories"
                              searchable
                            />

                            <div className="manual-main-action-container">
                              <button
                                type="button"
                                className="manual-question-inline-delete"
                                onClick={() => handleRemoveContent(index)}
                                aria-label="Remove question"
                              >
                                <DeleteIcon className="inline-delete-icon" />
                              </button>
                            </div>
                          </div>
                          <div className="manual-question-explanation-info">
                            <div>
                              <label className="manual-question-label">
                                Question {index + 1}
                              </label>
                              <input
                                className="manual-question-input"
                                value={content?.content?.question}
                                onChange={(e) => {
                                  setContentData((prev) => {
                                    const updated = [...prev];
                                    updated[index] = {
                                      ...updated[index],
                                      content: {
                                        ...updated[index]?.content,
                                        question: e?.target?.value,
                                      },
                                    };
                                    return updated;
                                  });
                                }}
                              />
                            </div>

                            <div>
                              <label className="manual-question-label">
                                Options
                              </label>

                              <div className="manual-question-options">
                                {Object.entries(content?.content?.options)?.map(
                                  ([key, value], oIdx) => (
                                    <div
                                      className="manual-question-option-row"
                                      key={`opt-${key}`}
                                    >
                                      <input
                                        type="radio"
                                        className="radio-input"
                                        checked={
                                          content?.content?.answer ===
                                          String.fromCharCode(65 + oIdx)
                                        }
                                        onChange={() => {
                                          setContentData((prev) => {
                                            const updated = [...prev];
                                            updated[index] = {
                                              ...updated[index],
                                              content: {
                                                ...updated[index]?.content,
                                                answer: String.fromCharCode(
                                                  65 + oIdx
                                                ),
                                              },
                                            };
                                            return updated;
                                          });
                                        }}
                                      />
                                      <input
                                        className="manual-question-input"
                                        value={value}
                                        placeholder={`Option ${key}`}
                                        onChange={(e) => {
                                          updateOption(
                                            index,
                                            key,
                                            e.target.value
                                          );
                                        }}
                                      />
                                      <div className="manual-question-action">
                                        <button
                                          type="button"
                                          className={`manual-question-inline-delete ${
                                            Object.keys(
                                              content?.content?.options
                                            ).length <= 2
                                              ? "disable-btn"
                                              : ""
                                          } `}
                                          onClick={() =>
                                            removeOption(index, key)
                                          }
                                          disabled={
                                            Object.keys(
                                              content?.content?.options
                                            ).length <= 2
                                          }
                                        >
                                          <DeleteIcon className="inline-delete-icon" />
                                        </button>
                                        {Object.keys(content?.content?.options)
                                          .length -
                                          1 ===
                                          oIdx && (
                                          <button
                                            type="button"
                                            className="iq-popup-action-btn-container"
                                            onClick={() => addOption(index)}
                                          >
                                            <AddCircleIcon className="inline-add-icon" />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                            <div>
                              <label className="manual-question-label">
                                Hint
                              </label>
                              <input
                                className="manual-question-input"
                                value={content?.hint}
                                onChange={(e) => {
                                  setContentData((prev) => {
                                    const updated = [...prev];
                                    updated[index] = {
                                      ...updated[index],
                                      hint: e?.target?.value,
                                    };
                                    return updated;
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="iq-test-create-ai-btn-container">
                        {
                          <button
                            type="button"
                            className="iq-test-create-ai-btn"
                            onClick={handleClickAddContent}
                            aria-label="Remove question"
                          >
                            + Add Question
                          </button>
                        }
                        <button
                          className={`iq-test-create-ai-btn ${
                            showPreviewQuestion?.length === 0
                              ? "disable-btn"
                              : ""
                          }`}
                          disabled={showPreviewQuestion?.length === 0}
                          onClick={() => {
                            if (
                              !showPreviewQuestion ||
                              showPreviewQuestion.length === 0
                            )
                              return;
                            setIsShowIQTestPreview(true);
                          }}
                        >
                          Show questions
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="iq-test-create-ai-categories-action-container">
                  <button
                    className={`iq-test-create-ai-btn ${
                      (contentData?.length === 0 && showPreviewQuestion?.length === 0) ? "disable-btn" : ""
                    }`}
                    onClick={handleClickSaveContent}
                  >
                    {isEditAction ? "Update" : "Save"}
                  </button>
                  {}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IqTestCreate;
